import { RouteConfig } from 'types/RouteConfig';

export const PrivateRouteConfig: Record<string, RouteConfig> = {
  TANK_MONITORS: {
    path: 'tank_monitors',
  },
  TANK_MONITORS_V2: {
    path: 'tank_monitors_v2',
  },
};
